import ReviewContainer from './ReviewContainer';

export default ReviewContainer;
